import React, { useEffect, useState, useRef } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import {
  superadmin_applications_view,
  superadmin_app_submit,
  superadmin_status,
  clear_financial_record_changes,
} from "../../admin.api";
import "../view.css";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import CustomIcons from "../../../../components/icons/kIcons.component";
import moment from "moment";
import * as XLSX from "xlsx";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function SuperAdminView(props) {
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [appdata, setAppdata] = useState({});
  const [adminStatus, setadminStatus] = useState({});
  const [count, setCount] = useState(1);
  const [printMode, setPrintMode] = useState(false);
  const [status, setStatus] = useState([
    {
      id: 3,
      status_title: "Revert to Admin",
      status_code: "3",
    },
    {
      id: 4,
      status_title: "Reject with Reason",
      status_code: "4",
    },
    {
      id: 2,
      status_title: "Accept",
      status_code: "2",
    },
  ]);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [statusLabel, setstatusLabel] = useState("");
  const [showAgreementPopup, setShowAgreementPopup] = useState(false);
  const [agreementFile, setAgreementFile] = useState(null);
  const [agreementRemark, setAgreementRemark] = useState("");
  const [showStartProjectPopup, setShowStartProjectPopup] = useState(false);
  const [startProjectRemarks, setStartProjectRemarks] = useState("");
  const [showCompletedPopup, setShowCompletedPopup] = useState(false);
  const [completionRemarks, setCompletionRemarks] = useState("");

  const handleCompleted = (e) => {
    e.preventDefault();
    setShowCompletedPopup(true);
  };

  const handleCompletedSubmit = () => {
    const form = new FormData();

    form.append("status_id", "8");
    form.append("completion_remarks", completionRemarks);
    form.append("application_id", appdata.id ?? null);

    superadmin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setShowCompletedPopup(false);
        setCompletionRemarks("");
        // Refresh the application data to get updated status
        getApplication();
      })
      .catch((err) => {
        setSnackMessage(err.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const { id } = useParams();
  const { id2 } = useParams();

  const onSearch = () => {
    //
  };
  const getApplication = () => {
    superadmin_applications_view(id)
      .then((res) => {
        setAppdata(res.data);
        setstatusLabel(res.applicattion_status_label);
      })
      .catch((err) => {
        setIsSnackError(true);
        setSnackOpen(true);
        setSnackMessage(err.response.data.message);
      });
  };
  const handleClearChanges = (recordId) => {
    // setIsActive(true);
    clear_financial_record_changes(recordId)
      .then((res) => {
        setSnackMessage(res.message || "Status cleared successfully");
        setIsSnackError(false);
        setSnackOpen(true);
        getApplication();
      })
      .catch((err) => {
        setSnackMessage(err.response?.data?.message || "An error occurred");
        setIsSnackError(true);
        setSnackOpen(true);
        // setIsActive(false);
      });
  };
  const handleFinancialRecordsDownload = () => {
    const financialRecords = appdata?.financial_records || [];

    if (!financialRecords.length) {
      setSnackMessage("No financial records available to download");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const exportData = financialRecords.map((record, index) => ({
      "Sl. No": index + 1,
      "Financial Year": record.financial_year || "",
      "Turnover (Cr)": record.fy_turnover || "",
      "Capital Investment (Cr)": record.capital_investment || "",
      "Direct Employment": record.direct_emp || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Financial Records");
    XLSX.writeFile(
      workbook,
      `Financial_Records_${moment().format("DD-MM-YYYY_HH-mm-ss")}.xlsx`
    );
  };
  // const getStatus = () => {
  //   superadmin_status(id).then((res) => {
  //     setStatus(res.data);
  //   });
  // };
  useEffect(() => {
    getApplication();
    // getStatus();
  }, []);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push(-1);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Prefill message when status_id = 2
    if (name === "status_id" && value == 2) {
      setadminStatus({
        ...adminStatus,
        status_id: value,
        message: "Your application is accepted for further processing",
      });
      setCount(count + 1);
      return;
    }

    // Default update
    setadminStatus({
      ...adminStatus,
      [name]: value,
    });

    setCount(count + 1);
  };


  const handleFileChange = (e) => {
    let size = e.target.files[0].size;

    let mb = size / Math.pow(1024, 2);

    if (mb < 1) {
      setadminStatus({
        ...adminStatus,
        file_name: e.target.files[0].name,
        [e.target.name]: e.target.files[0],
      });
    } else {
      setSnackMessage("File size is greater than 1MB");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };
  const handleAdminStatusUpdate = (e) => {
    e.preventDefault();
    const form = new FormData();

    form.append("file_name", adminStatus.file_name ?? null);

    // Determine which status_id to send to backend
    //  - Revert to Admin (status_id 3) => send 5
    //  - Accept (status_id 2)        => send 16
    //  - Others                      => send selected status_id as-is
    let finalStatusId = adminStatus.status_id;
    if (adminStatus.status_id == 2) {
      finalStatusId = 16;
    }

    form.append("status_id", String(finalStatusId ?? ""));
    form.append("sample_file", adminStatus.sample_file ?? "");

    if (adminStatus.status_id == 3) {
      form.append("super_admin_message", adminStatus.message ?? null);
    } else if (adminStatus.status_id == 2) {
      form.append("user_message", adminStatus.message ?? null);
    } else {
      form.append("user_message", adminStatus.message ?? null);
    }
    form.append("application_id", appdata.id ?? null);
    superadmin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((err) => {
        setSnackMessage(err.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const handleAgrementExecution = (e) => {
    e.preventDefault();
    setShowAgreementPopup(true);
  };

  const handleAgreementSubmit = () => {
    const form = new FormData();

    form.append("agreement_execution_file", agreementFile);
    form.append("status_id", "6");
    // form.append("sample_file", adminStatus.sample_file ?? "");
    form.append("agreement_execution_remarks", agreementRemark);
    form.append("application_id", appdata.id ?? null);

    superadmin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setShowAgreementPopup(false);
        setAgreementFile(null);
        setAgreementRemark("");
      })
      .catch((err) => {
        setSnackMessage(err.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const handleAgreementCancel = () => {
    setShowAgreementPopup(false);
    setAgreementFile(null);
    setAgreementRemark("");
  };
  const handleOngoing = (e) => {
    e.preventDefault();
    setShowStartProjectPopup(true);
  };

  const handleStartProjectSubmit = () => {
    const form = new FormData();

    form.append("status_id", "7");
    form.append("start_project_remarks", startProjectRemarks);
    form.append("application_id", appdata.id ?? null);

    superadmin_app_submit(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setShowStartProjectPopup(false);
        setStartProjectRemarks("");
      })
      .catch((err) => {
        setSnackMessage(err.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const handleStartProjectCancel = () => {
    setShowStartProjectPopup(false);
    setStartProjectRemarks("");
  };
  const handlePrint = () => {
    var originalContents = document.body.innerHTML;
    var printReport = document.getElementById("printable-area-super").innerHTML;
    document.body.innerHTML = printReport;
    window.print();
  };

  const handleDownloadProposal = () => {
    let path = `${result}${appdata.upload_proposal}`;
    window.open(path, "_blank");
  };
  const componentRef = useRef();
  const handleDownload = () => {
    let path = `${result}${appdata.logo}`;
    window.open(path, "_blank");
  };

  const flattenedAllocations = appdata.area_allocations?.map((item) => ({
    ...item,
    location: item.area_sub_table?.location?.locations ?? "",
    sub_location: item.area_sub_table?.sub_location ?? "",
    built_space_type_name: item.area_sub_table?.built_space_type?.name ?? "",
    category: item.area_sub_table?.built_space_type ? "Built-up Space" : "Land",
  }));

  const handleDownloadProposalOwn = () => {
    let path = `${result}${appdata.area_management[0]?.proposal_file}`;
    window.open(path, "_blank");
  };

  let message = [{ message: "Not Yet Alloted" }];
  return (
    <div>
      <div className="view-container">
        <div className="col-12 d-flex justify-content-end">
          <ReactToPrint
            onBeforePrint={() => setPrintMode(true)}
            onAfterPrint={() => setPrintMode(false)}
            trigger={() => (
              <button
                type="button"
                // onClick={(e) => handlePrint()}
                className="btn  btn-warning1 btn-sm mr-2 mb-2 dwnlded"
              >
                <CustomIcons iconName="download" iconClass="down" />
                Download info
              </button>
            )}
            content={() => componentRef.current}
          />

          <button
            type="button"
            onClick={(e) => handleDownloadProposal()}
            className="btn btn-success ml-2 btn-sm mb-2 "
          >
            <CustomIcons iconName="download" iconClass="down" />
            Download Proposal
          </button>
        </div>
        <form onSubmit={handleAdminStatusUpdate}>
          <div ref={componentRef} className={printMode ? "p-2" : "p-4"}>
            <div className="d-flex justify-content-between">
              <h6>
                <b>New Company Request</b>
              </h6>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  id2 == "kspace"
                    ? props.history.push("/company-request-list/kspace")
                    : props.history.push("/company-request-list/own");
                }}
              >
                Back
              </button>
            </div>

            <hr />
            <div className="data">
              <div className="row">
                <div className="col-3">Company Name</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.company_name ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Application ID</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.unique_application_ref_no ?? ""}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Contact Person Name</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.person_name ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Contact Person Designation</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.person_designation}</div>
              </div>
              <div className="row">
                <div className="col-3">Primary Mail Id</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.email ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Primary Contact No</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.phone_no ?? ""}</div>
              </div>
              {appdata.site_link && (
                <div className="row">
                  <div className="col-3">Website Link</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.site_link ?? ""}</div>
                </div>
              )}
              {appdata.logo && (
                <div className="row">
                  <div className="col-3">Company Logo</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {/* <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(appdata)}
                >
                  <b>Download Logo</b>
                </a> */}
                    <button
                      type="button"
                      onClick={(e) => handleDownload(appdata)}
                      className="btn btn-reject btn-dark btn-sm"
                    >
                      Download Logo
                    </button>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-3">Address</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.address ?? ""}</div>
              </div>
              {appdata.alternate_email && (
                <div className="row">
                  <div className="col-3">Alternate Mail Id</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.alternate_email ?? ""}</div>
                </div>
              )}
              {appdata.alternate_phone && appdata.country_code && (
                <div className="row">
                  <div className="col-3">Alternate Contact No</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    {appdata.alternate_phone && (
                      <>
                        {appdata.country_code &&
                          appdata.country_code !== "" &&
                          appdata.country_code !== "undefined" &&
                          appdata.country_code !== "null" && (
                            <>
                              {appdata.country_code ?? ""}{" "}
                              {appdata.country_code &&
                                appdata.country_code !== ""
                                ? "-"
                                : ""}{" "}
                            </>
                          )}
                      </>
                    )}
                    {appdata.alternate_phone ?? ""}
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-3">New company / Existing company ?</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {" "}
                  {appdata.company_status === "new_company"
                    ? "New Company"
                    : appdata.company_status === "existing_company"
                      ? "Existing Company"
                      : ""}
                </div>
              </div>
              {/* {appdata?.financial_records?.length > 0 && appdata.company_status === "existing_company" && ( */}
              {appdata?.financial_records?.length > 0 && (
                <>
                  <div className="row mt-4">
                    <div className="col-12 d-flex align-items-start justify-content-between">
                      <div>
                        <p className="mb-0" style={{ fontWeight: 700, fontSize: "15px" }}><b>Financial Records</b></p>
                        <p className="text-muted small mt-1">Review the financial history and recent changes for this application.</p>
                      </div>
                      <button
                        type="button"
                        className="financial-download-btn"
                        title="Download financial records"
                        onClick={handleFinancialRecordsDownload}
                      >
                        <CustomIcons iconName="download" iconClass="down" />
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <table className="table table-bordered financial-table">
                      <thead className="thead-light">
                        <tr>
                          <th>Financial Year</th>
                          <th>Turnover (Cr)</th>
                          {/* <th>Capital Investment (Cr)</th> */}
                          {/* <th>Male Employment</th>
                          <th>Female Employment</th>
                          <th>Others</th>
                          <th>SC/ST</th>
                          <th>PWD</th>
                          <th>Direct Emp</th> */}
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appdata.financial_records.map((record, index) => {
                          const status = record.financial_records_changed || "neutral";
                          const lastRecord = record.last_record ? JSON.parse(record.last_record) : null;

                          const renderVal = (field) => {
                            if (status === "updated" && lastRecord && lastRecord[field] !== undefined && String(lastRecord[field]) !== String(record[field])) {
                              return (
                                <div className="value-diff">
                                  <span className="old-val">{lastRecord[field]}</span>
                                  <span className="diff-arrow">→</span>
                                  <span className="new-val">{record[field]}</span>
                                </div>
                              );
                            }
                            return record[field];
                          };

                          return (
                            <tr key={record.id || index} className={`record-row-${status}`}>
                              <td><b>{record.financial_year}</b></td>
                              <td>{renderVal("fy_turnover")}</td>
                              {/* <td>{renderVal("capital_investment")}</td> */}
                              {/* <td>{renderVal("dir_employ_male")}</td>
                              <td>{renderVal("dir_employ_female")}</td>
                              <td>{renderVal("dir_employ_others")}</td>
                              <td>{renderVal("dir_employ_sc_st")}</td>
                              <td>{renderVal("dir_employ_pwd")}</td>
                              <td>{renderVal("direct_emp")}</td> */}
                              <td>
                                <div className="d-flex align-items-center justify-content-center">
                                  {status !== "neutral" && status !== "cleared" && (
                                    <button
                                      type="button"
                                      className="btn-clear-status"
                                      title={`Clear ${status} status`}
                                      onClick={() => handleClearChanges(record.id)}
                                    >
                                      <CustomIcons iconName="tick" />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {appdata?.financial_records?.length > 0 && (
                    <div className="mt-4">
                      <p className="mb-3" style={{ fontWeight: 700, fontSize: "15px", marginLeft: "16px" }}><b>Financial Records Chart</b></p>
                      <ResponsiveContainer width="100%" height={300}>
                        <BarChart
                          data={appdata.financial_records
                            .map(r => ({
                              financial_year: r.financial_year,
                              turnover: Number(r.fy_turnover) || 0,
                            }))
                            .sort((a, b) => a.financial_year.localeCompare(b.financial_year))}
                          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="financial_year" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="turnover" fill="#0A223D" name="Turnover (Cr)" barSize={40} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )}
                </>
              )}
              <div className="row">
                <div className="col-3">
                  Capital Investment Expected in Crores
                </div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.capital_investment ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Initial Direct Employment</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.ex_man_power ?? ""}</div>
              </div>
              <div className="row">
                <div className="col-3">Abstract Project Proposal</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.abstract_project_proposal ?? ""}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Product Profile</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata?.product_profiles?.map((item, i) => (
                    <div key={i}>
                      <div className="col-12 mb-1">
                        <b>{item.product_name ?? ""}</b>
                      </div>
                      <div className="col-12 mb-2 ">
                        <div>{ReactHtmlParser(item.product_desc)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="row">
                <div className="col-3">Domain Type</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata?.domain_types?.map((dom, i) => (
                    <div key={i}>{dom.domain_name}</div>
                  ))}
                  {(appdata?.any_other_flag == 1 ||
                    (appdata?.any_other_domain &&
                      appdata?.any_other_domain != null)) && (
                      <div>{appdata?.any_other_domain}</div>
                    )}

                  <></>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-3">Any Other Domain</div>
                <div className="col-1">:</div>
                <div className="col-7">{appdata.any_other_domain ?? ""}</div>
              </div> */}

              {/* <div className="row">
                <div className="col-3">Document Uploaded</div>
                <div className="col-1">:</div>
                <div className="col-7 ">{appdata?.file_name}</div>
              </div> */}
            </div>
            {appdata?.upload_proposal && (
              <div className="data">
                <div className="row mt-3">
                  <div className="col-3">Project Proposal</div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={(e) => handleDownloadProposal()}

                    >
                      Download Proposal
                    </button>
                  </div>
                </div>
              </div>
            )}
            <h6>
              <b>Area Requirements</b>
            </h6>

            <hr />
            <div className="data">
              {appdata.area_type === "built_up_space" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br> Built-up space on Rent per Month
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_type",
                          render: (rowData) =>
                            rowData.area_type === "built_up_space"
                              ? "Built-up Space"
                              : "Land",
                        },
                        {
                          title: "Built-Up Space Category",
                          field: "built_space_type",
                        },
                        {
                          title: "Area Requirement (Requested area in sqft)",
                          field: "area_in_sqft",
                        },
                        // {
                        //   title: "Investment model",
                        //   field: "investment_model",
                        // },
                        // { title: "Management plan", field: "management_plan" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "equipped_facility" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br> Equipped Facility per Month{" "}
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        {
                          title: "Requested Area Requirement",
                          field: "area_in_sqft",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "land_on" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br> Land on 30 years Lease{" "}
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_type",
                          render: (rowData) =>
                            rowData.area_type === "built_up_space"
                              ? "Built-up Space"
                              : "Land",
                        },
                        {
                          title: "Land Requirement(in cents)",
                          field: "area_in_acres",
                        },
                        { title: "Lease Years", field: "lease_year" },
                        // { title: "Address", field: "land_address" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "joint_venture" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br>Joint Venture
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7 venure">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Preference No", field: "id", type: "dynId" },
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        {
                          title: "Category",
                          field: "area_management_id",
                          render: (rowData) =>
                            rowData.area_management_id == 1
                              ? "Built-up Space"
                              : "Land",
                        },
                        {
                          title: "Area Type",
                          field: "built_space_type",
                        },
                        {
                          title: "Request Area",
                          render: (rowData) =>
                            rowData.area_management_id == 1
                              ? `${rowData.area_in_sqft ?? 0} Sq.ft`
                              : `${rowData.area_in_acres ?? 0} Cents`,
                        },
                        ...(appdata?.area_management?.some(item => item.area_management_id == 2) ? [{ title: "Lease Years", field: "lease_year" }] : []),
                        {
                          title: "Investment Model",
                          field: "investment_model",
                        },
                        { title: "Management Plan", field: "management_plan" },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_type === "own_land" && (
                <div className="row">
                  <div className="col-3">
                    Requested <br></br>Own Premises{" "}
                  </div>
                  <div className="col-1">:</div>
                  <div className="col-7">
                    <CustomTable
                      className="areatable"
                      {...props}
                      columns={[
                        { title: "Location", field: "location" },
                        { title: "Sub Location", field: "sub_location" },
                        { title: "Available Area", field: "area_in_sqft" },
                        { title: "Survey Number", field: "survey_no" },
                        { title: "Block Number", field: "block_no" },
                        { title: "Village Name", field: "village_name" },
                        { title: "Address of Property", field: "land_address" },
                        { title: "Management Plan", field: "management_plan" },
                        {
                          title: "Nature Of Holding",
                          field: "nature_of_holding",
                        },
                        {
                          title: "Interested in JV",
                          render: (rowData) =>
                            rowData.proposal_file ? "Yes" : "No",
                        },
                      ]}
                      data={appdata?.area_management}
                    />
                  </div>
                </div>
              )}
              {appdata.area_management?.[0]?.proposal_file != null &&
                appdata.area_type === "own_land" && (
                  <div className="row">
                    <div className="col-3">
                      Interested in Joint venture with KSPACE
                    </div>
                    <div className="col-1">:</div>
                    <div className="col-7">
                      {/* <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleDownload(appdata)}
                >
                  <b>Download Logo</b>
                </a> */}
                      <button
                        type="button"
                        onClick={(e) => handleDownloadProposalOwn(appdata)}
                        className="btn btn-reject btn-dark btn-sm"
                      >
                        Download Proposal
                      </button>
                    </div>
                  </div>
                )}
              {appdata.area_type !== "own_land" && appdata.area_type !== 'joint_venture' && (
                <>
                  {!appdata?.area_allocations ||
                    appdata?.area_allocations.length === 0 ? (
                    <div className="row mt-3">
                      <div className="col-3">Allocated</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        <CustomTable
                          className="areatable"
                          {...props}
                          columns={[
                            {
                              title: "Status",
                              field: "message",
                            },
                          ]}
                          data={message}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="row mt-3">
                      <div className="col-3">Allotted</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        <CustomTable
                          className="areatable"
                          {...props}
                          columns={[
                            {
                              title: "Location",
                              field: "location",
                            },
                            {
                              title: "Sub Location",
                              field: "sub_location",
                            },
                            {
                              title: "Category",
                              field: "category",
                            },
                            ...(flattenedAllocations.some(
                              (row) => row.category === "Built-up Space"
                            )
                              ? [
                                {
                                  title: "Built-up Space Type",
                                  field: "built_space_type_name",
                                },
                              ]
                              : []),
                            ...(flattenedAllocations.some(
                              (row) => row.category === "Land"
                            )
                              ? [
                                {
                                  title: "Lease Years",
                                  field: "years",
                                },
                              ]
                              : []),
                            {
                              title: "Load Factor",
                              field: "load_factor",
                            },
                            {
                              title: "Area Allotted",
                              field: "allotted_space",
                            },
                            {
                              title: "Total Rent (Rupees/month)",
                              field: "total_amount",
                            },

                          ]}
                          data={flattenedAllocations}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className="nio row ">
                <div className="col-3 ">Current Application Status</div>
                <div className="col-1">:</div>
                <div className="col-7 blink_me1">
                  {appdata?.application_status === 0
                    ? "Pending"
                    : appdata?.application_status == 1
                      ? "Submitted for acceptance"
                      : appdata?.application_status == 2
                        ? "Approved"
                        : appdata?.application_status == 3
                          ? "Super Admin Reverted"
                          : appdata?.application_status == 4
                            ? "Rejected"
                            : appdata?.application_status == 5
                              ? "Admin Reverted"
                              : appdata?.application_status == 6
                                ? "Agreement Execution"
                                : appdata?.application_status == 7
                                  ? "Ongoing Project"
                                  : appdata?.application_status == 8
                                    ? "Completed"
                                    : appdata?.application_status == 15
                                      ? "Company Suggestion"
                                      : appdata?.application_status == 16
                                        ? "Waiting for Company Approval"

                                        : "Agreement Execution"}
                </div>
              </div>
              {appdata?.to_super_admin_message_content &&
                appdata?.to_super_admin_message_content !== "" && (
                  <div className="row">
                    <div className="col-3">Message from Super Admin</div>
                    <div className="col-1">:</div>
                    <div className="col-7 ">
                      {appdata?.to_super_admin_message_content}
                    </div>
                  </div>
                )}
              {/* Agreement Execution Details */}
              {(appdata?.application_status === 6 || appdata?.application_status === 7 || appdata?.application_status === 8) && (
                <>
                  {appdata?.agreement_execution_file && (
                    <div className="nio row">
                      <div className="col-3 ">Uploaded File</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        <a
                          href={appdata.agreement_execution_file}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#007bff', textDecoration: 'underline' }}
                        >
                          View
                        </a>
                      </div>
                    </div>
                  )}

                  {appdata?.agreement_execution_remarks && (
                    <div className="nio row">
                      <div className="col-3 ">Remarks</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {appdata.agreement_execution_remarks}
                      </div>
                    </div>
                  )}

                  {appdata?.start_project_remarks && (
                    <div className="nio row">
                      <div className="col-3 ">Start Project Remarks</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {appdata.start_project_remarks}
                      </div>
                    </div>
                  )}

                  {appdata?.completion_remarks && (
                    <div className="nio row">
                      <div className="col-3 ">Completion Remarks</div>
                      <div className="col-1">:</div>
                      <div className="col-7">
                        {appdata.completion_remarks}
                      </div>
                    </div>
                  )}
                </>
              )}
              <div className="row">
                <div className="col-3">Created At</div>
                <div className="col-1">:</div>
                <div className="col-7">
                  {appdata.created_at
                    ? moment(appdata.created_at).format("DD-MM-YYYY")
                    : ""}
                </div>
              </div>

              {appdata?.to_admin_message_content &&
                appdata?.to_admin_message_content !== "" && (
                  <div className="row">
                    <div className="col-3">Message from Super Admin</div>
                    <div className="col-1">:</div>
                    <div className="col-7 ">
                      {appdata?.to_admin_message_content}
                    </div>
                  </div>
                )}

              {appdata?.application_status === 15 && appdata?.user_message && (
                <div className="row">
                  <div className="col-3">Company Suggestion</div>
                  <div className="col-1">:</div>
                  <div className="col-7">{appdata.user_message}</div>
                </div>
              )}
            </div>

            <>
              {(appdata.application_status === 1 || appdata.application_status === 15) && (
                <div className="px-4">
                  {/* {status?.length !== 0 && ( */}
                  <div className="col-6 mt-3 status">
                    <label>
                      <b>Select Action</b>
                    </label>
                    <select
                      className="form-select mt-2"
                      aria-label="Default select example"
                      onChange={handleChange}
                      name="status_id"
                      required
                      value={adminStatus.status_id}
                    >
                      <option value="">Select Action</option>
                      {status?.map((item) => (
                        <option value={item.id}>{item.status_title}</option>
                      ))}
                    </select>
                  </div>
                  {/* )} */}
                  {(appdata.application_status === 1 || appdata.application_status === 15) &&
                    (adminStatus.status_id == 3 ||
                      adminStatus.status_id == 4 ||
                      adminStatus.status_id == 2) && (
                      <div className="col-6 mt-3">
                        <div className="form-group">
                          {/* <label for="exampleFormControlTextarea1">Example textarea</label> */}
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            placeholder="Message.."
                            rows="3"
                            onChange={handleChange}
                            name="message"
                            value={adminStatus.message}
                            required
                          ></textarea>
                        </div>
                      </div>
                    )}

                  {status?.length !== 0 && (
                    <button type="submit" className="btn mb-2 mysubbtn">
                      Submit
                    </button>
                  )}
                </div>
              )}

              {appdata.application_status === 2 && (
                <button
                  onClick={(e) => handleAgrementExecution(e)}
                  className="btn mb-2 mysubbtn"
                >
                  Agreement Execution
                </button>
              )}
              {appdata.application_status === 6 && (
                <div className="d-flex justify-content-center">
                  <button
                    onClick={(e) => handleOngoing(e)}
                    className="btn mb-2 mysubbtn"
                  >
                    Start Project
                  </button>
                </div>
              )}
              {appdata.application_status === 7 && (
                <div className="d-flex justify-content-center">
                  <button
                    onClick={(e) => handleCompleted(e)}
                    className="btn mb-2 mysubbtn"
                  >
                    Completed
                  </button>
                </div>
              )}
            </>
          </div>
        </form>
      </div>

      {/* Agreement Execution Popup */}
      {showAgreementPopup && (
        <div className="overlay">
          <div className="big-dia1 dialog1" style={{ height: '480px' }}>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon1 " style={{ fontSize: "24px" }}>
                  Agreement Execution
                </div>
                <div className="dia-close" onClick={handleAgreementCancel}>
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
              <div className="tilebar">
                <hr />
              </div>

              <div className="book-form">
                <div className="col-12">
                  <label
                    className="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Upload Agreement File <span className="text-danger ">*</span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const maxSize = 2 * 1024 * 1024; // 2 MB
                        if (file.size > maxSize) {
                          setSnackMessage('File size must be less than 2 MB');
                          setIsSnackError(true);
                          setSnackOpen(true);
                          e.target.value = '';
                          return;
                        }
                        setAgreementFile(file);
                      }
                    }}
                    accept=".pdf,.doc,.docx"
                    required
                    style={{ border: "1px solid #9ca3af" }}

                  />
                  <small className="text-muted">
                    Accepted formats: PDF, DOC, DOCX
                  </small>
                </div>

                <div className="col-12 mt-3">
                  <label className="form-label"
                    style={{ fontSize: "15px" }}>
                    Remark <span className="text-danger"
                    >*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={agreementRemark}
                    onChange={(e) => setAgreementRemark(e.target.value)}
                    placeholder="Enter your remarks here..."
                    required
                    style={{ border: "1px solid #9ca3af" }}

                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ minWidth: "120px" }}
                      onClick={handleAgreementCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minWidth: "120px" }}
                      onClick={handleAgreementSubmit}
                      disabled={!agreementFile || !agreementRemark.trim()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Completed Popup */}
      {showCompletedPopup && (
        <div className="overlay">
          <div className="big-dia1 dialog1" style={{ height: '360px' }}>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon1" style={{ fontSize: "24px" }}>Completed</div>
                <div className="dia-close" onClick={() => { setShowCompletedPopup(false); setCompletionRemarks(""); }}>
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
              <div className="tilebar">
                <hr />
              </div>

              <div className="book-form">
                <div className="col-12">
                  <label
                    className="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Completion Remarks <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={completionRemarks}
                    onChange={(e) => setCompletionRemarks(e.target.value)}
                    placeholder="Enter completion remarks here..."
                    required
                    style={{ border: "1px solid #9ca3af" }}

                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ minWidth: "120px" }}
                      onClick={() => { setShowCompletedPopup(false); setCompletionRemarks(""); }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minWidth: "120px" }}
                      onClick={handleCompletedSubmit}
                      disabled={!completionRemarks.trim()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Start Project Popup */}
      {showStartProjectPopup && (
        <div className="overlay">
          <div className="big-dia1 dialog1" style={{ height: '350px' }}>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
            <div className="row">
              <div className="flexDisplay">
                <div className="diaTitleCon1" style={{ fontSize: "24px" }}>
                  Start Project
                </div>
                <div className="dia-close" onClick={handleStartProjectCancel}>
                  <div className="diaCloseCon">
                    <div className="diaClose">&#10005;</div>
                  </div>
                </div>
              </div>
              <div className="tilebar">
                <hr />
              </div>

              <div className="book-form">
                <div className="col-12">
                  <label
                    className="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Remarks <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={startProjectRemarks}
                    onChange={(e) => setStartProjectRemarks(e.target.value)}
                    placeholder="Enter your remarks here..."
                    required
                    style={{ border: "1px solid #9ca3af" }}
                  />
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ minWidth: "120px" }}
                      onClick={handleStartProjectCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minWidth: "120px" }}
                      onClick={handleStartProjectSubmit}
                      disabled={!startProjectRemarks.trim()}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
